import RankingItem from "./RankingItem";

export default function Rankings({ name, rankings, rankMatchesIndices, onRankChange = () => {}, }) {
  return rankings.map((ranking, index) => (
    <div className="col">
      <RankingItem
        name={name}
        pIndex={index}
        ranking={ranking}
        rankMatchesIndices={rankMatchesIndices}
        onRankChange={onRankChange}
      />
    </div>
  ));
}
